import * as hierarchyActions from "contexts/hierarchy/interface";
import { createSingletonSaveBlockerSet } from "./createSingletonSaveBlockerSet";
import { ISaveBlockers } from "./interface";

/**
 * Replaces the current validation blocker for a hierarchy property with the latest validation result.
 *
 * @param saveBlockers - Current application save blockers.
 * @param action - Validation save-blocker action to apply.
 * @returns The updated save blockers.
 */
export const app_reduceValidationSaveBlockers = (
  saveBlockers: ISaveBlockers,
  action: hierarchyActions.IHierarchyValidationSaveBlockerAction,
): ISaveBlockers => {
  const updatedBlockers = new Set(
    Array.from(saveBlockers).filter((blocker) => blocker.type !== action.propertyKey),
  );
  createSingletonSaveBlockerSet(action.propertyKey, action.warningText).forEach((blocker) =>
    updatedBlockers.add(blocker),
  );
  return updatedBlockers;
};
